import DocumentList from "./DocumentList";
import DocumentCreate from "./DocumentCreate";

export default {
    list: DocumentList,
    create: DocumentCreate,
    edit: DocumentCreate
}
